module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-6-f3d8a2410c66019dfa34205bacc1b0a2.jpg";